import { IChatMessage, IAiMessage } from '@/bundles/AiAgent/types';

export class ChatMessageMapper {
  static mapToModel (chatMessage: IChatMessage): IAiMessage {
    const aiMessage: IAiMessage = {
      id: chatMessage.id,
      role: chatMessage.role,
      content: chatMessage.content,
      timestamp: new Date(chatMessage.created_at),
    };

    if (!chatMessage.metadata) {
      return aiMessage;
    }

    if (chatMessage.metadata.record_type && chatMessage.metadata.items) {
      aiMessage.data = {
        record_type: chatMessage.metadata.record_type,
        items: chatMessage.metadata.items,
      };
    }

    if (chatMessage.metadata.execution_time_ms) {
      aiMessage.executionTimeMs = chatMessage.metadata.execution_time_ms;
    }

    if (chatMessage.metadata.is_error) {
      aiMessage.isError = chatMessage.metadata.is_error;
    }

    return aiMessage;
  }

  static mapToModels (chatMessages: IChatMessage[]): IAiMessage[] {
    return chatMessages.map(ChatMessageMapper.mapToModel);
  }
}
